export default __webpack_public_path__ + "static/media/download-certificate-home.4fd763a2.svg";